<app-loader *ngIf="isLoading"></app-loader>
<p-toast></p-toast>
<p-confirmDialog></p-confirmDialog>
<router-outlet></router-outlet>
